import { render, staticRenderFns } from "./SearchPager.vue?vue&type=template&id=50c62c8b&"
import script from "./SearchPager.vue?vue&type=script&lang=js&"
export * from "./SearchPager.vue?vue&type=script&lang=js&"
import style0 from "./SearchPager.vue?vue&type=style&index=0&id=50c62c8b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports